module.exports = {
	"offerInfo": "The dealer may accept an offer below the list price of {price}.",
	"offerInfoQty": "The dealer may accept an offer below the list price of {price} per item.",
	"labelOffer": "Your Best Offer",
	"continueCta": "Continue",
	"makeOfferHeader": "Make an Offer",
	"makeOfferPlaceholderPdp": "Let the dealer know why you are interested.",
	"footer": "You will be prompted for your shipping and payment information, but you will not be charged unless your offer is accepted.",
	"lowBallHeader": "Make an Offer",
	"lowBallLabelHeading": "Warning: ",
	"lowBallLabel": "An offer significantly below the {type} price of {price} will likely be rejected. We recommend raising your offer.",
	"lowBallOtherOptionLabel": "Enter another offer",
	"lowBallOptionAmountOff": "{amountOff} off, {percentOff}% discount",
	"lowBallOriginalOffer": "(original offer)",
	"cta": "Continue",
	"header": "Make an Offer",
	"placeholderPdp": "Let the dealer know why you are interested."
};


//////////////////
// WEBPACK FOOTER
// ./json/copy/make-offer.json
// module id = 1013
// module chunks = 4 6 8 9